import app from 'flarum/common/app';
import Tooltip from 'flarum/common/components/Tooltip';
import icon from 'flarum/common/helpers/icon';
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import extractText from 'flarum/common/utils/extractText';

export default class ForumStatsWidgetWidget extends Widget {
  className(): string {
    return 'Tf-StatsWidgetWidget';
  }

  icon(): string {
    return 'fa-light fa-chart-pie';
  }

  title(): string {
    return extractText(app.translator.trans('tf-stats-widget.forum.widget.title'));
  }

  content() {
    const stats = app.forum.attribute('tf-stats-widget.stats');

    return (
      <div className="Tf-StatsWidget-grid">
        {Object.keys(stats).map((stat, index) => (
          <div key={stat} className="Tf-StatsWidget-grid-item">
            {index > 0 && <div className="Tf-StatsWidget-grid-item-divider"></div>}
            <div className="Tf-StatsWidget-grid-item-content">
              <div className="Tf-StatsWidget-grid-item-header">
                <div className="Tf-StatsWidget-grid-item-icon">{icon(stats[stat].icon)}</div>
                <div className="Tf-StatsWidget-grid-item-label">{stats[stat].label}</div>
              </div>
              <div className="Tf-StatsWidget-grid-item-value">{stats[stat].prettyValue}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

